const changeLanguage = (field, isRtl = false) => {
  return isRtl ? field : field + "EN";
};
export default changeLanguage;
